export const safetyPageInitialState = {
  activePage: "",
  // Near Miss State
  selectedNearMiss: null,
  showNearMissForm: false,
  // Safety Audit Checklist State
  selectedSafetyAuditChecklist: null,
  showSafetyAuditChecklistForm: false,
  // Incident Investigation State
  //   selectedIncidentInvestigation: null,
  //   showIncidentInvestigationForm: false,
};
